module.exports = __webpack_public_path__ + "static/media/success.18231bc8.svg";